import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';
import { ToneDto } from '../../../dto/tonedto';

export interface SearchToneBasedOnCodeResponse extends MiddlewareAPIResponse
{
    getSearchToneDto():  ToneDto[];
}

export class SearchToneBasedOnCodeResponseDtoImpl extends MiddlewareDtoImpl implements SearchToneBasedOnCodeResponse
{
    private searchToneRespnseDto : ToneDto[];

    getSearchToneDto(): ToneDto[]
    {
        return this.searchToneRespnseDto;
    }
    setSearchToneDto(searchToneRespnseDto: ToneDto[])
    {
        this.searchToneRespnseDto = searchToneRespnseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/searchtonebasedoncode/searchtonebasedoncoderesponse.tsx